import permissions from 'constants/permissions'

const LEGAL_FRAMEWORK_LIST = [
  {
    name: 'Gerenciar',
    tag: permissions.LEGAL_FRAMEWORKS.MANAGE,
  },
]

export default LEGAL_FRAMEWORK_LIST
